<template>
  <v-container class="help-content">
    <v-row dense>
      <v-col cols="7">
        <v-img src="images/concept9.png" />
      </v-col>
      <v-col>
        <v-row dense>
          <v-col cols="1"></v-col>
            <v-col>
              <v-row dense>
                <v-col>
                  {{ $t("Helps.concept-8-1") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  1.
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-2-1") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-2-2") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  2。
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-3-1") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-3-2") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  3.
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-4-1") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-4-2") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  {{ $t("Helps.concept-8-5") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  4.
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-5-1") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-5-2") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  5.
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-6-1") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-6-2") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                  6.
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-7-1") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="1">
                </v-col>
                <v-col>
                  {{ $t("Helps.concept-8-7-2") }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  {{ $t("Helps.concept-8-8") }}
                </v-col>
              </v-row>
            </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </v-col> 
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style></style>
